//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noUiSlider from 'nouislider';

const formatter = {
  to: (input) => `${parseInt(input, 10)}%`, // convert to the range slider display format
  from: (sliderValue) => parseInt(sliderValue.replace('%', ''), 10), // convert back to an integer
};

export default {
  name: 'DpColourRangeSlider',
  props: {
    middle: { type: [Number, String], default: () => 50 },
    top: { type: [Number, String], default: () => 80 },
    range: { type: Object, default: () => ({ min: 0, max: 100 }) },
    orientation: { type: String, default: () => 'vertical' },
    positive: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      slider: null,
    };
  },
  watch: {
    middle() {
      this.updatePositions();
    },
    top() {
      this.updatePositions();
    },
    positive() {
      this.updateColours();
    },
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    if (this.slider) {
      this.slider.off('change');
    }
  },
  methods: {
    updatePositions() {
      if (!this.slider) {
        return;
      }

      this.slider.set([this.middle, this.top]);
    },
    updateColours() {
      // Add the connection colours
      const connect = this.$refs.slider.querySelectorAll('.noUi-connect');
      let classes = [];
      if (!this.positive) {
        classes = ['noui-slider-green', 'noui-slider-amber', 'noui-slider-red'];
      } else {
        classes = ['noui-slider-red', 'noui-slider-amber', 'noui-slider-green'];
      }

      for (let i = 0; i < connect.length; i += 1) {
        connect[i].classList.remove(classes[0], classes[2]); // make sure old classes are removed
        connect[i].classList.add(classes[i]);
      }
    },
    create() {
      this.slider = noUiSlider.create(this.$refs.slider, {
        orientation: this.orientation,
        range: this.range,
        connect: [true, true, true],
        start: [this.middle, this.top],
        step: 1,
        direction: 'rtl',
        tooltips: [true, true],
        pips: { mode: 'range', density: 3 },
        format: formatter,
      });

      this.slider.on('change', this.handleChange);
      this.updateColours();
    },
    handleChange() {
      const vals = this.slider.get();
      this.$emit('change', {
        middle: formatter.from(vals[0]),
        top: formatter.from(vals[1]),
      });
    },
  },
};
